<template>
  <div id="app">
    <v-idle style="display:none !important;" @idle="onidle"
  @remind="onremind" :duration="6000"/>
            
    <router-view/>
  <vue-touch-keyboard :options="options" v-if="visible" :layout="layout" :cancel="hide" :accept="accept" :input="input"/>
  </div>

</template>

<style lang="scss">
#app {
  height: 100%;
}

#nav {
  padding: 30px;
}
</style>

<style lang="scss">
  @import "src/assets/custom.scss";
</style>

<script>
export default {
  data() {
    return {
      boxTwo: '',
      visible: false
    }
  },
   methods: {
    onidle() {
      if (localStorage.getItem("CertNo") === null) {
        console.log('HERE')
      } else {
        localStorage.removeItem('CertNo');
        localStorage.removeItem('allowLOAConsult');
        localStorage.removeItem('allowLOALab');
        this.$router.push('/login');
      }
    },
    onremind(time) {
      // alert seconds remaining to 00:00
      alert(time);
    },
  }
}
</script>